import { Dialog } from "@headlessui/react";
import clsx from "clsx";
import * as React from "react";

type Props = React.PropsWithChildren<{
  className?: string;
}>;

const ModalTitle: React.FC<Props> = ({ className, children }) => (
  <div className="flex flex-col justify-around">
    <Dialog.Title
      as="h3"
      className={clsx("flex flex-row items-center justify-between", className)}
    >
      {children}
    </Dialog.Title>
  </div>
);

export default ModalTitle;
